import { useEffect, useState } from 'react'
import DressCode from '../components/DressCode'
import { EventFee } from '../components/EventFee'
import TimeTable from '../components/EventInfo/TimeTable'
import VenueAccess from '../components/EventInfo/VenueAccess'
import Gallery from '../components/Gallery'
import { Greeting } from '../components/Greeting'
import Hero from '../components/Hero'
import Navigation from '../components/Navigation'
import RSVPFormInline from '../components/RSVPFormInline'
import { Toaster } from '../components/ui/toaster'

export function Home() {
  const [currentSection, setCurrentSection] = useState('home')

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['schedule', 'access', 'dresscode', 'fee', 'rsvp']
      const scrollPosition = window.scrollY + 100

      for (const section of sections) {
        const element = document.getElementById(section)
        if (element) {
          const { offsetTop, offsetHeight } = element
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setCurrentSection(section)
            break
          }
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="relative min-h-screen pb-10 md:pb-0 md:pt-16 overflow-x-hidden">
      <Navigation currentSection={currentSection} />

      <div id="home">
        <Hero />
      </div>

      <div id="greeting" className="py-10">
        <div className="container mx-auto px-4 max-w-4xl">
          <Greeting />
        </div>
      </div>

      <div id="schedule" className="py-10">
        <div className="container mx-auto px-4 max-w-4xl">
          <TimeTable />
        </div>
      </div>

      <div id="access" className="py-10">
        <div className="container mx-auto px-4 max-w-4xl">
          <VenueAccess />
        </div>
      </div>

      <div id="dresscode" className="py-10">
        <div className="container mx-auto px-4 max-w-4xl">
          <DressCode />
        </div>
      </div>

      <div id="fee" className="py-10">
        <EventFee />
      </div>

      <div id="gallery" className="py-10 bg-white/50">
        <div className="container mx-auto px-4 max-w-6xl">
          <Gallery />
        </div>
      </div>

      <div id="rsvp" className="pt-10 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-dancing text-center mb-8">Attendance</h2>
          <RSVPFormInline />
        </div>
      </div>

      <Toaster />
    </div>
  )
}

export default Home
